var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logged-out"},[_c('div',[_c('b-card',{attrs:{"border-variant":"dark","header":"You have been logged out !!","align":"center"}},[_c('b-card-text',[_c('a',{staticClass:"login",attrs:{"href":_vm.url}},[_c('b-button',{attrs:{"variant":"primary"}},[_vm._v("Login")])],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }